import MenuConfigType from '@app/types/MenuConfigType';
import { FileTextOutlined } from '@ant-design/icons';

const fileAreaMenuConfig: MenuConfigType = {
  path: '/client-file-area/',
  title: 'File Area',
  key: 'FileArea',
  icon: FileTextOutlined,
  guard: [],
};

export default fileAreaMenuConfig;
